export default {"src":"/_next/static/image/public/images/ic_inperson_green.c82eb3c34a360c358ac66c7d1a28a0f6.svg","height":28,"width":28};